package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

data class ExclusionLabel(val parts: List<Part>) {
    data class Part(val text: String, val isName: Boolean)

    val text: String get() = parts.joinToString(" ") { it.text }
}

/**
 * Renders names in semi-bold and the words between them muted, so the relationship reads apart from the people.
 */
@Composable
fun ExclusionLabelText(label: ExclusionLabel) {
    label.parts.forEachIndexed { index, part ->
        if (index > 0) Text(" ")
        val modifier = if (part.isName) Modifier.fontWeight(FontWeight.SemiBold) else Modifier.color(AppColors.muted)
        Span(modifier.toAttrs()) { Text(part.text) }
    }
}
